"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogin = void 0;
const Api = __importStar(require("@src/api/auth"));
const account_context_1 = require("@src/context/account-context");
const socket_1 = require("@src/socket");
const types_1 = require("@src/types");
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const useAppMutation_1 = require("./useAppMutation");
const useConfig_1 = require("./useConfig");
const useLogin = (shouldStayOnSameUrl) => {
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_1.useHistory)();
    const config = (0, useConfig_1.useConfig)();
    const { refetchAccount } = (0, account_context_1.useAccountContext)();
    const { mutateAsync: login, isLoading, error, isError, } = (0, useAppMutation_1.useAppMutation)(Api.login, {
        onSuccess: async (data) => {
            await refetchAccount();
            antd_1.notification.success({
                message: intl.formatMessage({ id: 'general.notice' }),
                description: intl.formatMessage({ id: 'login.successfully_logged' }),
            });
            if (history.location.search === '?ref=back') {
                history.goBack();
            }
            else {
                let landingUrl = null;
                // @ts-ignore
                if (data.accountTypeId === config.accountType.company) {
                    landingUrl = '/admin';
                }
                else {
                    landingUrl = shouldStayOnSameUrl ? history.location.pathname : '/ucet';
                }
                history.pushLocalized(landingUrl);
            }
            socket_1.socket.emit(types_1.SocketEvents.ACCOUNT_AUTHENTICATED, data);
        },
        onError: (err) => {
            const { status } = err.response;
            if (status === 429) {
                antd_1.notification.error({
                    message: intl.formatMessage({ id: 'global.notification.attack' }),
                    description: intl.formatMessage({ id: 'global.notification.attack_description' }),
                });
            }
        },
    });
    return { login, isLoading, error, isError };
};
exports.useLogin = useLogin;
